import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b_ from 'b_';
import AuditStore from '../../stores/AuditStore';
import ConcurrencyPopUpStore, { CONCURRENCY_ISSUE } from '../../stores/ConcurrencyPopUpStore';
import FuseButton from '../FuseControls/FuseButton';
import FusePopUp from '../FuseControls/FusePopUp';
import { FTBody } from '../Fuse';
import Icon from '../Icon/Icon';
import './ConcurrencyPopUp.css';

const block = b_.lock('ConcurrencyPopUp');

class ConcurrencyPopUp extends Component {
    static propTypes = {
        store: ConcurrencyPopUpStore.PropType,
        audit: AuditStore.PropType,
        revisionType: PropTypes.string.isRequired,
    };

    openAudit = () => {
        const { audit, store, revisionType } = this.props;
        const { revision } = store;

        const urlQuery = audit.searchParamsToUrl([{
            type: revisionType,
            revisionId: revision.revisionId
        }]);
        window.open('/console/audit_log?search=' + urlQuery + '&openModal=true', '_blank');
    }

    actionText = {
        [CONCURRENCY_ISSUE.EDIT_AFTER_EDIT]: 'Overwrite Changes',
        [CONCURRENCY_ISSUE.EDIT_AFTER_DELETE]: 'Create New',
        [CONCURRENCY_ISSUE.DELETE_AFTER_EDIT]: 'Overwrite Changes',
    }

    render() {
        const { store } = this.props;
        if (!store) {
            return null;
        }

        const { revision } = store;
        const cmnProps = { className: block('Text') };

        return <FusePopUp
            className={block()}
            isOpen={store.isOpen.getValue()}
            title="Changes Detected"
            footer={
                <Fragment>
                    <FuseButton
                        type={'secondary'}
                        color={store.concurrencyIssue === CONCURRENCY_ISSUE.DELETE_AFTER_EDIT ? 'red' : 'blue'}
                        loading={store.status.isLoading}
                        fullWidth
                        className={block('Action', { type: 'confirm' })}
                        onClick={store.onConfirm}
                        qa={'concurrent-modal-force'}
                    >{this.actionText[store.concurrencyIssue]}</FuseButton>

                    <FuseButton
                        type={'primary'}
                        color={'blue'}
                        className={block('Action', { type: 'cancel' })}
                        fullWidth
                        onClick={store.cancel}
                        qa={'concurrent-modal-cancel'}
                    >Return to Edit</FuseButton>
                </Fragment>
            }
        >

            <FTBody {...cmnProps}>
                Changes were made to this item while you were editing it.
            </FTBody>
            <FTBody {...cmnProps}>
                The most recent changes were made by:
                <div className={block('Author')}> {revision?.actorEmail} </div>
            </FTBody>
            <FTBody {...cmnProps}>
                If you&apos;d like to review the changes before overwriting, please
                <div className={block('Link')} data-qa={'concurrency-audit-cta'} onClick={this.openAudit}>
                   click here to open the Audit Log in a new tab
                    <Icon
                        style={{
                            verticalAlign: 'text-top',
                            fontSize: 24,
                            marginLeft: 4
                        }}
                        type={'open_in_new'}
                    />
                </div>
            </FTBody>
            <FTBody>
                If you continue and overwrite, previous changes will be lost.
            </FTBody>
        </FusePopUp>;
    }
}

export default inject('audit')(observer(ConcurrencyPopUp));
